import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap",
  {
    variants: {
      variant: {
        default: "bg-background text-text-main border-border",
        success: "bg-success-bg text-success border-success/20",
        warning: "bg-warning-bg text-warning border-warning/20",
        danger: "bg-danger-bg text-danger border-danger/20",
        info: "bg-info-bg text-info border-info/20",
        deactivated: "bg-deactivated-bg text-deactivated border-deactivated/20",
        accent: "bg-accent/20 text-primary border-accent/40",
      },
    },
    defaultVariants: { variant: "default" },
  }
);

export function Badge({ className, variant, dot = false, ...props }) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props}>
      {dot && <span className={cn("h-1.5 w-1.5 rounded-full bg-current")} />}
      {props.children}
    </span>
  );
}

export { badgeVariants };
